import React from "react";
import { Layout } from "../../containers";
import { Container } from "./styled";

function ThankYou() {
  return (
    <Layout>
      <Container>
        <h2 style={{ marginBottom: "0" }}>Gacias por tu consulta!</h2>
        <p>En breve nos estaremos comunicando</p>
        <img src="../../assets/thank-you-icon-02.jpg" alt="thank you" />
        <a className="btn-primary" href="/">
          Volver al inicio
        </a>
      </Container>
    </Layout>
  );
}

export default ThankYou;
